import { emitNotification } from "@impero-com/ui";

export function emitNotificationOnQueryParam(
    paramName: string,
    paramValue: string,
    message: string,
    level: "error" | "warning" | "info" | "success"
) {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    if (
        params &&
        params.get(paramName) &&
        params.get(paramName)?.toLowerCase() === paramValue.toLowerCase()
    ) {
        emitNotification(level, message);
        params.delete(paramName);
        if (window.history && window.history.pushState) {
            window.history.pushState(
                { path: url.toString() },
                "",
                url.toString()
            );
        }
    }
}
